/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import IGrupoActividadEconomica from './entidades/grupoActividadEconomica';

export default class ModeloGrupoActividadEconomica {
    public consultarGrupoActividadEconomica() {
        return manejadorRest<IRespuesta<IGrupoActividadEconomica>>(() =>
            seguridad.get('GrupoActividadEconomica/ConsultarListaGrupoActividadEconomica')
        );
    }
    public crearGrupoActividadEconomica(grupoActividadEconomica: IGrupoActividadEconomica) {
        return manejadorRest<IRespuesta<IGrupoActividadEconomica>>(() =>
            seguridad.post('GrupoActividadEconomica/GuardarGrupoActividadEconomica', grupoActividadEconomica)
        );
    }
    public editarGrupoActividadEconomica(grupoActividadEconomica: IGrupoActividadEconomica) {
        return manejadorRest<IRespuesta<IGrupoActividadEconomica>>(() =>
            seguridad.put('GrupoActividadEconomica/EditarGrupoActividadEconomica', grupoActividadEconomica)
        );
    }
    public eliminarGrupoActividadEconomica(grupoActividadEconomica: IGrupoActividadEconomica) {
        return manejadorRest<IRespuesta<IGrupoActividadEconomica>>(() =>
            seguridad.delete('GrupoActividadEconomica/EliminarGrupoActividadEconomica', grupoActividadEconomica)
        );
    }
}
